'use client';

import globalDomains from '@/utils/global-domains';
import {useSearchParams} from 'react-router-dom';

/**
 * IOS의 유니버설 링크 동작을 우회하기 위한 리다이렉션 전용 더미 라우트입니다.
 * 사용자가 /events/bridge?url=https://m.sooplive.co.kr/ 같은 방식으로 이 라우트에 진입하게 된다면, url 파라미터로 전달받은 페이지를 향해 리다이렉션 시켜주게 됩니다.
 * Conf 추가 설정을 최소화하기 위해 Events 페이지 내부에서 정의되었습니다.
 * @returns
 */
const Bridge = () => {
  const [params] = useSearchParams();

  const targetUrl = params.get('url') || `${globalDomains.M_AFREECATV}`;

  window.location = targetUrl;

  return <></>;
};

export default Bridge;
